import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _93bbb23c = () => interopDefault(import('../../../pages/completed.vue' /* webpackChunkName: "pages/completed" */))
const _12ecaed2 = () => interopDefault(import('../../../pages/confirm.vue' /* webpackChunkName: "pages/confirm" */))
const _217bae63 = () => interopDefault(import('../../../pages/data.vue' /* webpackChunkName: "pages/data" */))
const _0d9b9bea = () => interopDefault(import('../../../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _0eec15e5 = () => interopDefault(import('../../../pages/order.vue' /* webpackChunkName: "pages/order" */))
const _3b9e415f = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _fbe95dd4 = () => interopDefault(import('../../../pages/result.vue' /* webpackChunkName: "pages/result" */))
const _bbd66efe = () => interopDefault(import('../../../pages/sctl.vue' /* webpackChunkName: "pages/sctl" */))
const _bfc1d8c4 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _13bd552e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _172a97be = () => interopDefault(import('../../../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/completed",
    component: _93bbb23c,
    name: "completed"
  }, {
    path: "/confirm",
    component: _12ecaed2,
    name: "confirm"
  }, {
    path: "/data",
    component: _217bae63,
    name: "data"
  }, {
    path: "/maintenance",
    component: _0d9b9bea,
    name: "maintenance"
  }, {
    path: "/order",
    component: _0eec15e5,
    name: "order"
  }, {
    path: "/privacy",
    component: _3b9e415f,
    name: "privacy"
  }, {
    path: "/result",
    component: _fbe95dd4,
    name: "result"
  }, {
    path: "/sctl",
    component: _bbd66efe,
    name: "sctl"
  }, {
    path: "/terms",
    component: _bfc1d8c4,
    name: "terms"
  }, {
    path: "/",
    component: _13bd552e,
    name: "index"
  }, {
    path: "/:slug",
    component: _172a97be,
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
